module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADEAAAAxCAMAAABEQrEuAAAAS1BMVEUAAACZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZkI0+mmAAAAGHRSTlMAaGw5Y5mWPZJgwnJcM9mon4RK7M2yKxLXCtyaAAAAhUlEQVRIx83SyQ3AIAwAQZMQct+X+680ggqyPJD9H5lFFhMzDeuLgFPVlQJdABg1zvEfVAn0FHgMYLQ6CjyOpt86WYrGGzzakB/dU+AsfSu+pYNGyx3BLgKzl5mQoHFaQjpOmkRq9LAiW7ZEZnv5+VvskVAkP2Q/zOiNDYJasJD9vB4pPB/+pxYX4kqjAQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/appDownLoad/pc/forward.png
// module id = LVsa
// module chunks = 1